import { useWoody } from '../../woody/woody.js';
import { useMutation } from '@tanstack/react-query';
import { toast } from '../../store/alerts.js';

const useMutationCopyResources = () => {
  const { client } = useWoody();
  const mutation = useMutation({
    mutationFn: async (variables) => {
      const resourceIds = variables.resources.map(({ id }) => id);
      return client.v2({
        endpoint: "/v2/resources/{destinationParentId}/copy",
        params: {
          destinationParentId: variables.parent.id
        }
      }, {
        method: "put",
        body: {
          resourceIds
        },
        query: {
          accessToken: variables.accessToken
        }
      });
    },
    onSuccess: (_, { disableToast }) => {
      if (!disableToast) {
        toast({
          id: "resource-paste",
          content: "Pasting"
        });
      }
    }
  });
  return mutation;
};

export { useMutationCopyResources };
//# sourceMappingURL=useMutationCopyResource.js.map
